// extracted by mini-css-extract-plugin
export default {"tableRow":"UserManagement_tableRow__Rec1c"};